import { useParams } from "react-router-dom";
import PostulationSuccess from "../../common/components/postulation-response/success";
import FailedPostulation from "../../common/components/postulation-response/failed";
import { GoBack } from "../../common/components/controls/goback";

export default function VerifySubscription() {

  const { status } = useParams();

  return (
    <>
      <GoBack goBackNumOfPages={-2}/>
      
      {status && <PostulationSuccess />}
      {!status && <FailedPostulation />}
    </>
  )
}